import React, { useState, useEffect } from 'react';
import head1Image from '../../Assets/Head1.png';
import head2Image from '../../Assets/Head2.png';
import head3Image from '../../Assets/Head3.png';
import head4Image from '../../Assets/Head4.png';
import head5Image from '../../Assets/Head5.png';

const HeroCarousel = ({ title, subtitle, showButton = false, buttonText = '', buttonAction = null, height = 'h-screen', contentPosition = 'center' }) => {
  const heroImages = [
    head1Image,
    head2Image,
    head3Image,
    head4Image,
    head5Image
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Auto-rotate carousel every 7 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 7000);

    return () => clearInterval(interval);
  }, [heroImages.length]);

  // Determine content positioning classes
  const positionClasses = contentPosition === 'bottom' 
    ? 'justify-end pb-12' 
    : 'justify-center';

  return (
    <div className={`relative ${height} overflow-hidden`}>
      {/* Carousel Images */}
      {heroImages.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${
            index === currentImageIndex ? 'opacity-100' : 'opacity-0'
          }`}
          style={{ 
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${image})` 
          }}
        />
      ))}

      {/* Hero Content */}
      <div className={`absolute inset-0 flex flex-col ${positionClasses} px-6 md:px-12 lg:px-24 z-10`}>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white font-serif mb-4">
          {title}
        </h1>
        {subtitle && (
          <p className="text-white text-lg md:text-xl max-w-2xl mb-8 font-sf-pro">
            {subtitle}
          </p>
        )}
        {showButton && buttonText && (
          <div>
            <button 
              onClick={buttonAction}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-8 rounded-md transition duration-300 font-sf-pro"
            >
              {buttonText}
            </button>
          </div>
        )}
      </div>

      {/* Carousel Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
        {heroImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentImageIndex(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentImageIndex 
                ? 'bg-white w-8' 
                : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;
